// extracted by mini-css-extract-plugin
export default {"badges":"ProductDetailSlideBadges_badges__DeHr9","badge":"ProductDetailSlideBadges_badge__UKahQ","badgeSalePercent":"ProductDetailSlideBadges_badgeSalePercent__mSDGy"};